import { useParams } from 'react-router-dom';
import BreadcrumbLayout from './BreadcrumbLayout';
import { getFarmPath } from '../utils/utils';
import { BreadcrumbHeaderProps } from '../components/layout/BreadcrumbHeader';

interface FarmBreadcrumbLayoutProps extends BreadcrumbHeaderProps {
  farmPath: string;
}

const FarmBreadcrumbLayout = ({
  farmPath,
  ...breadcrumbProps
}: FarmBreadcrumbLayoutProps) => {
  const { farmId } = useParams();
  const rootUrl = getFarmPath(farmId, farmPath);
  return <BreadcrumbLayout rootUrl={rootUrl} {...breadcrumbProps} />;
};

export default FarmBreadcrumbLayout;
